import React, { useState, useEffect } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { customStyles, extract_time } from "../../../utils/data/essential";
import { paymentHeaders } from "../../../utils/data/reportData";
import { useSelector } from "react-redux";
import { selectLocationName } from "../../../redux/slice/LocationNameSlice";
import { useFetchData } from "../../../hooks/useFetchData";
import { paymentColumns } from "../../../utils/columns/payments";
import { useParams } from "react-router-dom";
const MonthlyPayments = () => {
  const [payments, setPayments] = useState([]);
  const { locationId } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  const locationName = useSelector(selectLocationName);
  const locations = JSON.parse(localStorage.getItem("locations"));
  const selectedLocation = locationName || locations[locations.length - 1].name;
    const columns = paymentColumns();
    const firstdate = moment().startOf("month").format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
  const extractData = (data) => {
    let obj = {};
    let arr = [];
    data.forEach((el) => {
      obj.id = el.id;
      obj.datetime = moment(el.datetime).format("DD/MM/YYYY HH:mm:ss");
      obj.collectionAccount = el.collectionAccount;
      obj.transactionId = el.transactionId;
      obj.payer = el.payer;
      obj.amount = el.amount;
      obj.paymentInfo = el.paymentInfo;
      obj.accountId = el.accountId;
      obj.accountNames = el.accountNames;
      obj.province = el.province;
      obj.district = el.district;
      obj.sector = el.sector;
      obj.cell = el.cell;
      obj.village = el.village;
      arr.push(obj);
      obj = {};
    });
    setPayments(arr);
  };

  // Fetch payments data
  const url = `payments/collections/display?location=${locationId}&startdate=${firstdate}&enddate=${today}`;
  const { isLoading,data } = useFetchData(["fetch-monthly-payments"], url,true,user);

  useEffect(() => {
    if (data) {
      extractData(data);
    }
  }, [data]);
    if (isLoading)
      return (
        <div
          className='d-flex justify-content-center'
          style={{ marginTop: "15%" }}
        >
          <img
            src='/assets/img/loading.gif'
            alt='loading'
            width={100}
            height={100}
          />
        </div>
      );
  return (
    <div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Payments</h3>
      </div>
      {payments?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={payments}
            headers={paymentHeaders}
            filename={`payment_report_${extract_time()}`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={payments?.length === 0}
              style={{
                backgroundColor: payments?.length === 0 ? "#cbcbcb" : "#124db1",
                color: payments?.length === 0 ? "#000" : "",
                cursor: payments?.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}

      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={payments}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
    </div>
  );
};

export default MonthlyPayments;
